import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Card, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React from 'react';
import CustomButton from './CustomButton';


const ResponsiveTable = ({ data }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <TableContainer
            component={Card}
            sx={{
                p: isMobile ? 1 : 2,   // Reduced padding for mobile 
                margin: 'auto'
            }}
        >
            <Typography
                variant="h1"
                sx={{
                    fontSize: { xs: '1rem', sm: '1.2rem', md: '1.4rem' },
                    fontWeight: 600,
                    textAlign: 'center',
                    mb: isMobile ? 1 : 2,  // Reduced bottom margin for mobile
                }}
            >
                {data.title}
            </Typography>

            <Table>
                {data.headers && data.headers.length > 0 &&
                    <TableHead>
                        <TableRow>
                            {data.headers.map((value, index) =>
                                <TableCell
                                    key={index}
                                    sx={{
                                        fontWeight: 'bold',  // Changed to bold
                                        fontSize: isMobile ? '0.75rem' : '0.9rem',
                                        whiteSpace: 'nowrap',
                                        padding: isMobile ? '4px 8px' : '6px 12px',  // Reduced padding
                                    }}
                                >
                                    {value}
                                </TableCell>
                            )}
                        </TableRow>
                    </TableHead>
                }
                <TableBody>
                    {data.rows.map((row, rowIndex) =>
                        <TableRow key={rowIndex}>
                            {row.map((value, dataIndex) =>
                                <TableCell
                                    key={dataIndex}
                                    sx={{
                                        fontWeight: 500,
                                        fontSize: isMobile ? '0.75rem' : '0.9rem',
                                        whiteSpace: 'nowrap',
                                        padding: isMobile ? '4px 8px' : '6px 12px'  // Reduced padding
                                    }}
                                >
                                    {value}
                                </TableCell>
                            )}
                        </TableRow>
                    )}
                </TableBody>

            </Table>
            {(data.editButtonFn || data.deleteButtonFn) &&
                <Grid container spacing={1}>
                    <Grid item size={{ xs: 6, sm: 6, md: 6 }}>
                        <CustomButton
                            onClick={() => data.editButtonFn()}
                            color="success"
                        >
                            <EditIcon />
                        </CustomButton>
                    </Grid>
                    <Grid item size={{ xs: 6, sm: 6, md: 6 }}>
                        <CustomButton
                            onClick={() => data.deleteButtonFn()}
                            color="error"
                        >
                            <DeleteIcon />
                        </CustomButton >
                    </Grid>
                </Grid>
            }
        </TableContainer>
    );
};

export default ResponsiveTable;
